export const CANCELED_SIGNATURE_LINK =
  'https://api.whatsapp.com/send?phone=5551993057019';
export const PLANS_MBC_LINK = 'https://box.bibliotecacatolica.com.br/planos';
